(window as any).Intercom('boot', {
  app_id: 'jceziuaf'
});

export const environment = {
  production: true,
  staging: false,
  dev: false
};
